import { render, staticRenderFns } from "./essential.vue?vue&type=template&id=4d89d412&scoped=true"
import script from "./essential.vue?vue&type=script&lang=js"
export * from "./essential.vue?vue&type=script&lang=js"
import style0 from "./essential.vue?vue&type=style&index=0&id=4d89d412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d89d412",
  null
  
)

export default component.exports